/**
 * 将「1. xxx 2. xxx」「1、xxx」等同一段内的分点拆成多行；已换行的先按行再拆内联序号。
 * @param {string|null|undefined} text
 * @returns {string[]} 每项一行展示，无分点则整段为单项
 */
export function splitNumberedLines(text) {
  if (text == null || text === '') return []
  const raw = String(text).trim()
  if (!raw) return []

  const lines = raw.split(/\n+/).map((s) => s.trim()).filter(Boolean)
  if (lines.length > 1) {
    return lines.flatMap((line) => splitInlineNumbered(line))
  }
  return splitInlineNumbered(lines[0] || raw)
}

/** 序号：1-3 位数字 + . 或顿号、 + 空格 */
const ITEM_HEAD = /\d{1,3}\s*[.\u3001、]\s+/

function splitInlineNumbered(t) {
  const s = t.trim()
  if (!s) return []

  const numStart = s.search(new RegExp(ITEM_HEAD.source))
  const out = []

  if (numStart > 0) {
    const pre = s.slice(0, numStart).trim()
    if (pre) out.push(pre)
  }

  const from = numStart >= 0 ? s.slice(numStart) : s
  const re = /(\d{1,3})\s*[.\u3001、]\s+([\s\S]*?)(?=\d{1,3}\s*[.\u3001、]\s+|$)/g
  let m
  while ((m = re.exec(from)) !== null) {
    out.push(`${m[1]}. ${(m[2] || '').trim()}`)
  }

  if (out.length > 0) return out
  return [s]
}

/**
 * 列表卡片：先分条，再按「全文最多 maxTotal 个字符」截断（与原单行 truncate 总预算一致）。
 * 按条顺序累加，最后一条可带 …
 * @param {string|null|undefined} text
 * @param {number} maxTotal
 * @returns {string[]}
 */
export function splitNumberedLinesForPreview(text, maxTotal) {
  const lines = splitNumberedLines(text)
  const n = Math.max(0, Math.floor(Number(maxTotal)))
  if (lines.length === 0 || n === 0) return []

  const out = []
  let used = 0
  for (const line of lines) {
    const remaining = n - used
    if (remaining <= 0) break
    if (line.length <= remaining) {
      out.push(line)
      used += line.length
    } else {
      const cut = remaining >= 4 ? remaining - 3 : remaining
      const suffix = remaining >= 4 ? '...' : ''
      out.push(line.slice(0, cut) + suffix)
      break
    }
  }
  return out
}
